<app-fixed-black-background>
    <div class="text-wrapper">
        <div class="flex center icon-display">
            <i class="fal fa-exclamation-triangle fa-5x"></i>
        </div>
        <div class="flex center">
            <h5>{{ 'MODAL.BROWSER-DETECT-OVERLAY.DOWNLOAD-CHROME-BROWSER.TITLE' | translate }}</h5>
        </div>
        <div class="flex center">
            <p class="description">
                {{ 'MODAL.BROWSER-DETECT-OVERLAY.DOWNLOAD-CHROME-BROWSER.DESCRIPTION' | translate }}
                <a class="download-link" href="{{ downloadChromeBrowser }}" target="_blank">
                    {{ 'MODAL.BROWSER-DETECT-OVERLAY.DOWNLOAD-CHROME-BROWSER.DESCRIPTION-LINK' | translate }}
                </a>
            </p>
        </div>
        <div class="flex center">
            <button class="button underlined" (click)="continueAnyway()">
                {{ 'MODAL.BROWSER-DETECT-OVERLAY.DOWNLOAD-CHROME-BROWSER.BUTTON.CLOSE' | translate }}
            </button>
            <button class="button outlined" (click)="downloadGoogleChrome()">
                {{ 'MODAL.BROWSER-DETECT-OVERLAY.DOWNLOAD-CHROME-BROWSER.BUTTON.OKAY' | translate }}
            </button>
        </div>
    </div>
</app-fixed-black-background>
